// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.no-results-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  text-align: center;
  color: #8c8c8c;
}
.no-results-message mat-icon {
  font-size: 48px;
  margin-bottom: 8px;
  color: var(--fc-brand, #5ea1d8);
}

/* Search Content - No margin needed, app.component handles layout */
.search-content {
  padding: 24px;
  background-color: #ffffff;
  min-height: calc(100vh - 56px);
  width: 100%;
}

.org-library-home {
  margin-bottom: 24px;
}

.org-library-home__header h2 {
  margin: 0 0 12px;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a1a1a;
}

.org-library-empty {
  color: #777;
  margin: 0 0 16px;
  font-size: 0.9rem;
}

.org-library-thumb {
  background: linear-gradient(135deg, #eef5fb, #f7faf8);
  position: relative;
}

.org-library-thumb .thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.org-library-thumb__placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--fc-brand, #5ea1d8);
}

.org-library-thumb__placeholder mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
}

.org-library-home .video-card {
  cursor: pointer;
}

.org-library-home .video-card.skeleton-card {
  cursor: default;
  pointer-events: none;
}

.org-library-type-label,
.org-library-status {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
}

.org-library-status {
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(94, 161, 216, 0.12);
  color: #0b3d5c;
}

.org-library-home .channel-meta-row {
  gap: 6px;
  min-width: 0;
}

.org-library-home .channel-info {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
}

.org-library-home .channel-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.org-library-home .org-library-unique-id,
.org-library-home .video-views {
  flex: 0 0 auto;
  max-width: 45%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 4px;
}

/* Mobile search header for search page */
.mobile-search-header {
  position: sticky;
  top: 0;
  z-index: 8;
  background: #ffffff;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid #eee;
}
.mobile-search-header .icon-btn {
  border: none;
  background: transparent;
  padding: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #212427;
}
.mobile-search-header .mobile-search-input {
  flex: 1;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
}

/* All header, sidebar, and layout styles moved to app.component.scss */
/* COMMENTED OUT - These styles are now in app.component.scss
.flow-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.menu-button {
  background: none;
  border: none;
  color: #000000;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.menu-button:hover {
  background-color: #f0f0f0;
}

.flow-logo {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.flow-logo img {
  height: 20px;
  width: auto;
}

.flow-search-container {
  flex: 1;
  max-width: 640px;
  margin: 0 40px;
}

.search-box {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #d0d0d0;
  border-radius: 40px;
  overflow: hidden;
  height: 40px;
}

.flow-search-input {
  flex: 1;
  background: none;
  border: none;
  color: #000000;
  padding: 0 16px;
  font-size: 16px;
  outline: none;
}

.flow-search-input::placeholder {
  color: #666666;
}

.search-button {
  background: #f5f5f5;
  border: none;
  color: #000000;
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.search-button:hover {
  background-color: #e0e0e0;
}

.flow-header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-icon {
  background: none;
  border: none;
  color: #000000;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: background-color 0.2s;
}

.header-icon:hover {
  background-color: #f0f0f0;
}

.notification-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  background-color: #ff0000;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-image {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

/* Flow layout sidebar */
.flow-sidebar {
  position: fixed;
  left: 0;
  top: 56px;
  width: 240px;
  height: calc(100vh - 56px);
  background-color: #ffffff;
  border-right: 1px solid #e0e0e0;
  overflow-y: auto;
  transition: transform 0.3s ease;
  z-index: 999;
}

.flow-sidebar.sidebar-collapsed {
  transform: translateX(-100%);
}

.sidebar-content {
  padding: 12px 0;
}

.sidebar-section {
  margin-bottom: 8px;
}

.sidebar-section h3 {
  color: #666666;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  padding: 8px 24px;
  margin: 0;
}

.sidebar-item {
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;
  padding: 10px 24px;
  background: none;
  border: none;
  color: #000000;
  cursor: pointer;
  font-size: 14px;
  text-align: left;
  transition: background-color 0.2s;
}

.sidebar-item:hover {
  background-color: #f0f0f0;
}

.sidebar-item.active {
  background-color: #f0f0f0;
  font-weight: 500;
}

.sidebar-item mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

/* Search Content - Full width, app.component handles layout */
.search-content {
  padding: 24px;
  background-color: #ffffff;
  min-height: 100vh;
  width: 100%;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .search-content {
    padding: 12px;
    padding: 0px !important;
    padding-bottom: 60px; /* prevent content underlap with fixed footer */
  }
  .category-filter-bar {
    margin-bottom: 16px;
    margin-top: 6px;
    padding: 8px 16px;
    position: sticky;
    z-index: 999;
    background-color: #ffffff;
    align-items: center;
  }
  .video-grid {
    gap: 8px;
  }
}
/* Category Filter Bar */
.category-filter-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.category-filter-bar::-webkit-scrollbar {
  display: none;
}

.category-scroll-container {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 0;
  flex: 1;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.category-scroll-container::-webkit-scrollbar {
  display: none;
}

.category-chip {
  background-color: #f0f0f0;
  color: #000000;
  border: none;
  padding: 8px 16px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s;
  outline: none;
}
.category-chip:focus, .category-chip:active, .category-chip:focus-visible {
  outline: none;
  border: none;
  box-shadow: none;
}

.category-chip:hover {
  background-color: #e0e0e0;
}

.category-chip.active {
  background-color: var(--fc-brand, #5ea1d8);
  color: #ffffff;
}

/* ── Filter toggle button ── */
.filter-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  margin-left: auto;
  background: #f0f0f0;
  color: #000;
  border: none;
  padding: 8px 14px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s;
  position: relative;
}
.filter-toggle-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}
.filter-toggle-btn:hover {
  background-color: #e0e0e0;
}
.filter-toggle-btn.filter-active {
  background-color: var(--fc-brand, #5ea1d8);
  color: #fff;
}

.filter-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  background: #fff;
  color: var(--fc-brand, #5ea1d8);
  font-size: 11px;
  font-weight: 700;
  margin-left: 2px;
  padding: 0 4px;
}

/* ── Filter modal ── */
.filter-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1000;
  animation: fadeIn 0.15s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.filter-modal {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 20px 20px 0 0;
  z-index: 1001;
  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.12);
  animation: slideUp 0.22s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}
@media (min-width: 600px) {
  .filter-modal {
    left: 50%;
    right: auto;
    bottom: auto;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 420px;
    border-radius: 16px;
    animation: scaleIn 0.18s cubic-bezier(0.4, 0, 0.2, 1);
    max-height: 90vh;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes scaleIn {
  from {
    opacity: 0;
    transform: translate(-50%, -48%) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}
.filter-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 12px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.filter-modal-title {
  font-size: 16px;
  font-weight: 700;
  color: #111;
}

.filter-modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #555;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  transition: background 0.15s;
}
.filter-modal-close mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}
.filter-modal-close:hover {
  background: #f0f0f0;
}

.filter-modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.filter-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.filter-section-label {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
}

/* Sort option pills */
.filter-sort-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.filter-sort-btn {
  background: #f0f0f0;
  color: #333;
  border: 2px solid transparent;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.filter-sort-btn:hover {
  background: #e4e4e4;
}
.filter-sort-btn.selected {
  background: #e8f2fb;
  border-color: var(--fc-brand, #5ea1d8);
  color: #1d67a3;
  font-weight: 600;
}

/* Price range inputs */
.filter-price-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-price-field {
  display: flex;
  align-items: center;
  background: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 0 10px;
  flex: 1;
  transition: border-color 0.15s;
}
.filter-price-field:focus-within {
  border-color: var(--fc-brand, #5ea1d8);
}
.filter-price-field .price-currency {
  color: #777;
  font-size: 13px;
  margin-right: 4px;
  -webkit-user-select: none;
          user-select: none;
}

.filter-input {
  border: none;
  outline: none;
  width: 100%;
  padding: 9px 0;
  font-size: 15px;
  background: transparent;
  color: #111;
}
.filter-input::placeholder {
  color: #aaa;
}
.filter-input::-webkit-inner-spin-button, .filter-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.price-range-sep {
  color: #bbb;
  font-size: 18px;
  flex-shrink: 0;
}

/* Modal footer — only shown when filters are active */
.filter-modal-footer {
  padding: 8px 20px 20px;
  border-top: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.filter-reset-btn {
  background: #f5f5f5;
  color: #444;
  border: none;
  padding: 11px 20px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}
.filter-reset-btn:hover {
  background: #eaeaea;
}
.filter-reset-btn--full {
  width: 100%;
}

/* Multi-item Items query terms (same chip look; row above category tabs) */
.item-query-terms-bar {
  margin-bottom: 0;
}

.item-query-term-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: default;
  padding-right: 6px;
  background-color: #e3f2fd !important;
  color: #1d67a3 !important;
  border: 1px solid #bfdbfe;
}

.item-query-term-text {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #1d67a3 !important;
}

.item-query-term-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(29, 103, 163, 0.14);
  color: #1d67a3;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;
}

.item-query-term-remove:hover,
.item-query-term-remove:focus-visible {
  background: rgba(29, 103, 163, 0.24);
  outline: none;
}

/* Video Grid */
.video-grid-container {
  width: 100%;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  padding: 0;
  width: 100%;
}

.video-card {
  background-color: transparent;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.2s;
  cursor: pointer;
  content-visibility: auto;
  contain-intrinsic-size: auto 280px;
}

@media (hover: hover) and (pointer: fine) {
  .video-card:hover {
    transform: translateY(-2px);
  }
}
.video-thumbnail {
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  background-color: #f5f5f5;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 12px;
}

.thumbnail-image,
.thumbnail-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-duration {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 3px;
}
.video-duration .duration-icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
  line-height: 13px;
}

.bundle-badge {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 10;
  width: 25px !important;
  height: 25px !important;
  max-width: 25px !important;
}
.bundle-badge img {
  width: 100% !important;
  height: auto !important;
  object-fit: contain;
  border: none;
}

/* Sponsored badge — bottom-left corner of thumbnail, same style as duration badge */
.sponsored-card-badge {
  position: absolute;
  bottom: 8px;
  left: 8px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 3px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  pointer-events: none;
}
.sponsored-card-badge mat-icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
  line-height: 13px;
}

/* Price badge in the top-right corner with 50% transparent background */
.price-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
  background-color: rgba(33, 36, 39, 0.77); /* Flowchest black @ 50% */
  color: var(--fc-brand, #5ea1d8);
  font-weight: 600;
  font-size: 20px;
  margin: -7px;
  line-height: 1;
  padding: 6px 10px;
  border-radius: 6px;
  -webkit-backdrop-filter: saturate(120%);
          backdrop-filter: saturate(120%);
}

.video-info {
  display: flex;
  gap: 0; /* no gap since avatar is now inside video-details */
}

/* Mobile-only tweak: slight left margin for video info row */
@media (max-width: 768px) {
  .video-info {
    margin-left: 5px;
  }
}
.video-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-icon {
  width: 100%;
  height: 100%;
  font-size: 70px;
  color: #666666 !important;
}

.video-details {
  flex: 1;
  min-width: 0;
  display: flex; /* stacked layout */
  flex-direction: column;
  gap: 0; /* no spacing between rows */
  margin: 0;
  padding: 0;
}

.video-title-row {
  display: flex;
  align-items: flex-start;
  gap: 8px; /* proper spacing between title and menu */
  margin: 0; /* no extra space below title */
  margin-bottom: 0 !important;
  padding: 0;
  justify-content: space-between;
}

.video-title {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  margin: 0;
  margin-bottom: 0px !important;
  line-height: 1.3; /* proper line height for readability */
  display: -webkit-box;
  -webkit-line-clamp: 2; /* allow 2 lines to show full title */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  flex: 1;
  min-width: 0;
  padding: 0;
  padding-right: 4px; /* space for menu button */
  word-wrap: break-word;
  word-break: break-word;
}

.video-title:hover {
  color: #666666;
}

.video-menu-button {
  background: none;
  border: none;
  color: #212427;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
  flex-shrink: 0;
  margin: 0;
  margin-top: 0 !important;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  min-height: 28px;
}
.video-menu-button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin: 0;
  padding: 0;
  line-height: 1;
}
.video-menu-button:hover {
  color: #212427;
  background-color: #f5f5f5;
}

.video-card:hover .video-menu-button {
  opacity: 1;
}

/* Mobile: Show unique code and more_vert icon always visible */
@media (max-width: 768px) {
  .video-menu-button {
    opacity: 1; /* Always visible on mobile */
  }
}
.channel-meta-row {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
  margin-top: -2px !important; /* negative margin to eliminate gap */
  padding: 0;
  flex-wrap: nowrap;
  line-height: 1; /* minimal line height */
  justify-content: space-between;
  position: relative;
}

.channel-meta-row > *:not(.video-views) {
  flex-shrink: 0;
}

.channel-info {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
  margin-top: 2px; /* slight spacing from title */
}

.channel-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

.avatar-image-small {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-icon-small {
  width: 100%;
  height: 100%;
  font-size: 24px;
  color: #212427;
}

.channel-name {
  font-size: 13px;
  color: #606060;
  margin: 0px !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  margin-left: 0px !important;
  margin-right: 0px !important;
  line-height: 1.3;
  cursor: pointer;
  white-space: nowrap;
}

.channel-name:hover {
  color: #000000;
}

/* YouTube-style collab: overlapping avatars + "name and @coauthor" */
.avatar-stack {
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.avatar-stack .video-avatar {
  position: relative;
  z-index: 1;
}
.avatar-stack .collab-avatar-overlap {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
  margin-left: -7px;
  border: 2px solid #fff;
  z-index: 2;
  position: relative;
  flex-shrink: 0;
}
.avatar-stack .collab-avatar-extra {
  position: relative;
  width: 20px;
  height: 20px;
  margin-left: -7px;
  z-index: 3;
  flex-shrink: 0;
  cursor: pointer;
}
.avatar-stack .collab-avatar-extra .collab-extra-img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff;
  display: block;
}
.avatar-stack .collab-avatar-extra .collab-extra-badge {
  position: absolute;
  bottom: -3px;
  right: -4px;
  background: #3b82f6;
  color: #fff;
  font-size: 7px;
  font-weight: 700;
  border-radius: 8px;
  padding: 1px 3px;
  line-height: 1.2;
  white-space: nowrap;
}

.collab-extra-count-text {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
}
.collab-extra-count-text:hover {
  text-decoration: underline;
}

.collab-sep {
  color: #888;
  font-weight: 400;
  font-size: 11px;
}

.collab-coname {
  font-weight: 500;
  cursor: pointer;
}
.collab-coname:hover {
  text-decoration: underline;
}

.avatar-stack-wrap {
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.collab-stack-clickable {
  cursor: pointer;
}

.collab-popup-backdrop {
  position: fixed;
  inset: 0;
  z-index: 499;
  background: rgba(0, 0, 0, 0.45);
}

.collab-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 500;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.22), 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px 16px 14px;
  width: 300px;
}
.collab-popup .collab-popup-title {
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f4f6;
  margin-bottom: 10px;
  text-align: center;
}
.collab-popup .collab-popup-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s;
}
.collab-popup .collab-popup-card:hover {
  background: #f5f7fa;
}
.collab-popup .collab-popup-avatar-wrap {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  border: 2px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
}
.collab-popup .collab-popup-pic {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.collab-popup .collab-popup-icon {
  font-size: 34px;
  width: 34px;
  height: 34px;
  color: #9ca3af;
  line-height: 1;
}
.collab-popup .collab-popup-uname {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a2e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.video-meta {
  display: flex;
  gap: 4px;
  font-size: 12px;
  color: #606060;
  margin: 0;
  margin-top: 2px; /* slight spacing from channel */
  line-height: 1.3;
}

.video-views,
.video-time {
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  color: #1d67a3;
  background-color: #e3f2fd;
  padding: 3px 8px;
  border-radius: 4px;
  white-space: nowrap;
  display: inline-block;
  line-height: 1.2;
  letter-spacing: 0.3px;
  align-self: center;
  margin-left: auto;
}

/* Align unique code with more_vert icon on the same line */
.video-details {
  position: relative;
}

.channel-meta-row .video-views {
  margin-left: auto;
  margin-top: 0;
  margin-bottom: 0;
}

/* .video-price replaced by overlay price-badge on thumbnail */
.price-tag {
  background-color: #ff0000;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

/* User Grid */
.user-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  padding: 0;
}

.user-card {
  background-color: #f9f9f9;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: background-color 0.2s;
}

.user-card:hover {
  background-color: #f0f0f0;
}

.user-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
  background: linear-gradient(135deg, #f5f5f5 0%, #f5f5f5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-name {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  margin: 0 0 4px 0;
  cursor: pointer;
}

.user-name:hover {
  color: #666666;
}

.user-fullname {
  font-size: 14px;
  color: #666666;
  margin: 0 0 12px 0;
}

.user-role-chip {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: #eef5fb;
  color: var(--fc-brand, #5ea1d8);
}

.user-role-chip--none {
  background: #fff1e0;
  color: #b45309;
}

.follow-button {
  background-color: #f0f0f0;
  color: #000000;
  border: none;
  padding: 8px 16px;
  border-radius: 18px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.follow-button:disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

.btn-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
  animation: follow-spin 0.7s linear infinite;
  vertical-align: middle;
}

@keyframes follow-spin {
  to {
    transform: rotate(360deg);
  }
}
.follow-button:hover {
  background-color: #e0e0e0;
}

.follow-button.following {
  background-color: #000000;
  color: #ffffff;
}

/* Skeleton Loading */
.skeleton-card {
  background-color: #f9f9f9;
  border-radius: 12px;
  overflow: hidden;
}

.skeleton-thumbnail {
  width: 100%;
  aspect-ratio: 16/9;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  margin-bottom: 12px;
}

.skeleton-info {
  display: flex;
  gap: 12px;
  padding: 0 12px 12px 12px;
}

.skeleton-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  flex-shrink: 0;
}

.skeleton-details {
  flex: 1;
  min-width: 0;
}

.skeleton-title {
  height: 16px;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 8px;
  width: 80%;
}

.skeleton-channel {
  height: 14px;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 4px;
  width: 60%;
}

.skeleton-meta {
  height: 14px;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  width: 40%;
}

.skeleton-user-info {
  flex: 1;
  min-width: 0;
}

.skeleton-name {
  height: 16px;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 8px;
  width: 70%;
}

.skeleton-name--short {
  width: 45%;
  height: 12px;
}

.user-card.skeleton-card {
  pointer-events: none;
}
.user-card.skeleton-card .skeleton-user-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  flex-shrink: 0;
}

.skeleton-button {
  height: 32px;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 16px;
  width: 80px;
}

@keyframes skeleton-loading {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
/* Loading Spinner */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f0f0f0;
  border-top: 4px solid #000000;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* End Message */
.end-message {
  text-align: center;
  padding: 40px 20px;
  color: #666666;
}

.end-message h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 400;
}

/* Notification Menu */
.notification-menu {
  max-width: 400px;
  max-height: 500px;
  overflow-y: auto;
}

.notification-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
}

.notification-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.notification-avatar-icon {
  width: 40px;
  height: 40px;
  font-size: 40px;
  color: #666666;
  flex-shrink: 0;
}

.notification-content {
  flex: 1;
  min-width: 0;
}

.notification-message {
  display: block;
  font-size: 14px;
  color: #000000;
  margin: 0 0 4px 0;
  line-height: 1.5;
  white-space: pre-line;
}

.notification-time {
  font-size: 12px;
  color: #666666;
}

/* Profile Menu */
.profile-menu {
  min-width: 200px;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .flow-sidebar {
    transform: translateX(-100%);
  }
  .flow-main-content {
    margin-left: 0;
  }
  .flow-sidebar.sidebar-collapsed {
    transform: translateX(0);
  }
  .flow-main-content.sidebar-collapsed {
    margin-left: 240px;
  }
}
@media (max-width: 1024px) {
  .video-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 768px) {
  .flow-header {
    padding: 0 8px;
  }
  .flow-search-container {
    margin: 0 16px;
  }
  .flow-main-content {
    padding: 16px;
  }
  .video-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  .user-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 480px) {
  .flow-search-container {
    margin: 0 8px;
  }
  .search-box {
    height: 36px;
  }
  .flow-search-input {
    font-size: 14px;
    padding: 0 12px;
  }
  .search-button {
    padding: 6px 12px;
  }
  .video-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .flow-main-content {
    padding: 8px;
  }
}
/* Card edge behaviors on search page */
@media (min-width: 993px) {
  /* Desktop: square edge on hover */
  .video-card:hover {
    border-radius: 0 !important;
  }
  .video-card:hover .video-thumbnail {
    border-radius: 0 !important;
  }
  .video-card:hover .thumbnail-image,
  .video-card:hover .thumbnail-video {
    border-radius: 0 !important;
  }
}
@media (max-width: 767px) {
  /* Mobile: full-width with square edges */
  .video-card,
  .video-thumbnail {
    border-radius: 0 !important;
  }
}
/* Mobile Bottom Navigation (keep existing) */
.div1 {
  height: 50px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #e0e0e0;
}

.foot-ico {
  width: 100%;
  margin: 0px auto;
  display: flex;
  align-items: center;
  height: 100%;
}

.foot-ico ul {
  display: flex;
  list-style: none;
  align-items: center;
  justify-content: center;
  margin: 0px;
  width: 100%;
  padding: 0px;
}

.foot-ico ul li {
  margin: 0px;
  width: 25px;
  height: 25px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 2px;
}

.foot-ico ul li span {
  color: #666666;
  font-size: 20px;
  text-align: center;
  display: block;
}

.foot-ico ul li .icon-text {
  font-size: 10px;
  color: #666666;
  text-align: center;
  font-family: "Roboto", sans-serif;
}

.foot-ico ul li img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

@media (min-width: 992px) {
  .div1 {
    display: none;
    font-size: 10px;
    color: #666666;
    text-align: center;
    font-family: "Roboto", sans-serif;
  }
}
.foot-ico ul li img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

@media (min-width: 992px) {
  .div1 {
    display: none;
  }
}
/* Search page dark theme */
:host-context(body.theme-dark) {
  /* Keep Items multi-term chips identical to search/header badge colors in dark mode */
  /* Collaborators popup — dark mode */
  /* ── Filter toggle button ── */
  /* ── Filter modal backdrop ── */
  /* ── Filter modal ── */
  /* ── Filter sections ── */
  /* Sort pills */
  /* Price range inputs */
  /* Footer */
}
:host-context(body.theme-dark) .search-content {
  background-color: #0a0c10;
}
:host-context(body.theme-dark) .mobile-search-header {
  background: #0f172a;
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
}
:host-context(body.theme-dark) .mobile-search-header .icon-btn {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .mobile-search-header .mobile-search-input {
  background: #111827;
  border-color: rgba(148, 163, 184, 0.35);
  color: #e2e8f0;
}
:host-context(body.theme-dark) .mobile-search-header .mobile-search-input::placeholder {
  color: #94a3b8;
}
:host-context(body.theme-dark) .category-filter-bar {
  background-color: #0a0c10 !important;
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
  /* More air so the rule is not tight against the chips (above) or the grid (below) */
  margin-bottom: 20px;
  padding-top: 4px;
}
:host-context(body.theme-dark) .category-scroll-container {
  background: transparent;
  padding-bottom: 0;
}
:host-context(body.theme-dark) .category-chip {
  background-color: #1f2937;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .category-chip:hover,
:host-context(body.theme-dark) .category-chip:active {
  background-color: #374151;
}
:host-context(body.theme-dark) .category-chip.active {
  background-color: var(--fc-brand, #5ea1d8);
  color: #ffffff;
}
:host-context(body.theme-dark) .item-query-term-chip,
:host-context(body.theme-dark) .item-query-term-chip.category-chip,
:host-context(body.theme-dark) .item-query-term-chip.category-chip.active {
  background-color: #e3f2fd !important;
  color: #1d67a3 !important;
  border-color: #bfdbfe !important;
}
:host-context(body.theme-dark) .item-query-term-chip .item-query-term-text {
  color: #1d67a3 !important;
}
:host-context(body.theme-dark) .item-query-term-chip .item-query-term-remove {
  background: rgba(29, 103, 163, 0.14) !important;
  color: #1d67a3 !important;
}
:host-context(body.theme-dark) .item-query-term-chip .item-query-term-remove:hover,
:host-context(body.theme-dark) .item-query-term-chip .item-query-term-remove:focus-visible {
  background: rgba(29, 103, 163, 0.24) !important;
}
@media (max-width: 768px) {
  :host-context(body.theme-dark) .category-filter-bar {
    background-color: #0a0c10 !important;
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
    margin-bottom: 18px;
    padding-top: 2px;
  }
  :host-context(body.theme-dark) .category-scroll-container {
    padding-bottom: 0;
  }
  :host-context(body.theme-dark) .category-chip {
    background-color: #1f2937 !important;
    color: #e5e7eb !important;
  }
  :host-context(body.theme-dark) .category-chip:hover,
  :host-context(body.theme-dark) .category-chip:active,
  :host-context(body.theme-dark) .category-chip:focus-visible {
    background-color: #374151 !important;
    color: #f8fafc !important;
  }
  :host-context(body.theme-dark) .category-chip.active {
    background-color: var(--fc-brand, #5ea1d8) !important;
    color: #ffffff !important;
  }
  :host-context(body.theme-dark) .item-query-term-chip,
  :host-context(body.theme-dark) .item-query-term-chip.category-chip,
  :host-context(body.theme-dark) .item-query-term-chip.category-chip.active {
    background-color: #e3f2fd !important;
    color: #1d67a3 !important;
    border-color: #bfdbfe !important;
  }
  :host-context(body.theme-dark) .item-query-term-chip .item-query-term-text {
    color: #1d67a3 !important;
  }
}
:host-context(body.theme-dark) .video-thumbnail {
  background-color: #111827;
}
:host-context(body.theme-dark) .video-title {
  color: #f3f4f6;
}
:host-context(body.theme-dark) .video-title:hover {
  color: #d1d5db;
}
:host-context(body.theme-dark) .channel-name {
  color: #9ca3af;
}
:host-context(body.theme-dark) .channel-name:hover {
  color: #e5e7eb;
}
:host-context(body.theme-dark) .avatar-stack .collab-avatar-overlap {
  border-color: #1f2937;
}
:host-context(body.theme-dark) .avatar-stack .collab-avatar-extra {
  border-color: #1f2937;
  background: #374151;
  color: #d1d5db;
}
:host-context(body.theme-dark) .collab-sep {
  color: #6b7280;
}
:host-context(body.theme-dark) .collab-coname {
  color: #9ca3af;
}
:host-context(body.theme-dark) .video-menu-button {
  color: #cbd5e1;
}
:host-context(body.theme-dark) .video-menu-button:hover {
  color: #f8fafc;
  background-color: rgba(255, 255, 255, 0.08);
}
:host-context(body.theme-dark) .video-views,
:host-context(body.theme-dark) .video-time {
  background-color: rgba(94, 161, 216, 0.2);
  color: #93c5fd;
}
:host-context(body.theme-dark) .user-card {
  background-color: #111827;
  border: 1px solid rgba(148, 163, 184, 0.2);
}
:host-context(body.theme-dark) .user-card:hover {
  background-color: #1f2937;
}
:host-context(body.theme-dark) .user-name {
  color: #f3f4f6;
}
:host-context(body.theme-dark) .user-fullname {
  color: #9ca3af;
}
:host-context(body.theme-dark) .user-role-chip {
  background: rgba(94, 161, 216, 0.25);
  color: #bae6fd;
}
:host-context(body.theme-dark) .user-role-chip--none {
  background: rgba(245, 158, 11, 0.2);
  color: #fcd34d;
}
:host-context(body.theme-dark) .follow-button {
  background-color: #1f2937;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .follow-button:hover {
  background-color: #374151;
}
:host-context(body.theme-dark) .follow-button.following {
  background-color: var(--fc-brand, #5ea1d8);
  color: #ffffff;
}
:host-context(body.theme-dark) .skeleton-card {
  background-color: #111827;
}
:host-context(body.theme-dark) .skeleton-thumbnail,
:host-context(body.theme-dark) .skeleton-avatar,
:host-context(body.theme-dark) .skeleton-title,
:host-context(body.theme-dark) .skeleton-channel,
:host-context(body.theme-dark) .skeleton-meta,
:host-context(body.theme-dark) .skeleton-name,
:host-context(body.theme-dark) .skeleton-button {
  background: linear-gradient(90deg, #1f2937 25%, #374151 50%, #1f2937 75%);
  background-size: 200% 100%;
}
:host-context(body.theme-dark) .end-message,
:host-context(body.theme-dark) .no-results-message {
  color: #9ca3af;
}
:host-context(body.theme-dark) .div1 {
  background-color: #0f172a;
  border-top: 1px solid rgba(148, 163, 184, 0.2);
}
:host-context(body.theme-dark) .foot-ico ul li .icon-text,
:host-context(body.theme-dark) .foot-ico ul li span {
  color: #cbd5e1;
}
:host-context(body.theme-dark) .avatar-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .avatar-icon-small {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .user-avatar {
  background: transparent !important;
}
:host-context(body.theme-dark) .collab-popup {
  background: #1f2937;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.6), 0 2px 10px rgba(0, 0, 0, 0.4);
}
:host-context(body.theme-dark) .collab-popup .collab-popup-title {
  color: #64748b;
  border-bottom-color: rgba(148, 163, 184, 0.15);
}
:host-context(body.theme-dark) .collab-popup .collab-popup-card:hover {
  background: #374151;
}
:host-context(body.theme-dark) .collab-popup .collab-popup-avatar-wrap {
  border-color: #374151;
  background: #111827;
}
:host-context(body.theme-dark) .collab-popup .collab-popup-icon {
  color: #6b7280;
}
:host-context(body.theme-dark) .collab-popup .collab-popup-uname {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .filter-toggle-btn {
  background: #1f2937;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .filter-toggle-btn:hover {
  background: #374151;
}
:host-context(body.theme-dark) .filter-toggle-btn.filter-active {
  background: var(--fc-brand, #5ea1d8);
  color: #fff;
}
:host-context(body.theme-dark) .filter-badge {
  background: #0f172a;
  color: #93c5fd;
}
:host-context(body.theme-dark) .filter-modal-backdrop {
  background: rgba(0, 0, 0, 0.6);
}
:host-context(body.theme-dark) .filter-modal {
  background: #1e293b;
  box-shadow: 0 -4px 32px rgba(0, 0, 0, 0.5);
}
:host-context(body.theme-dark) .filter-modal-header {
  border-bottom-color: rgba(148, 163, 184, 0.15);
}
:host-context(body.theme-dark) .filter-modal-title {
  color: #f1f5f9;
}
:host-context(body.theme-dark) .filter-modal-close {
  color: #94a3b8;
}
:host-context(body.theme-dark) .filter-modal-close:hover {
  background: rgba(148, 163, 184, 0.12);
}
:host-context(body.theme-dark) .filter-section-label {
  color: #64748b;
}
:host-context(body.theme-dark) .filter-sort-btn {
  background: #111827;
  color: #cbd5e1;
  border-color: transparent;
}
:host-context(body.theme-dark) .filter-sort-btn:hover {
  background: #374151;
  color: #f1f5f9;
}
:host-context(body.theme-dark) .filter-sort-btn.selected {
  background: rgba(94, 161, 216, 0.15);
  border-color: var(--fc-brand, #5ea1d8);
  color: #93c5fd;
}
:host-context(body.theme-dark) .filter-price-field {
  background: #111827;
  border-color: rgba(148, 163, 184, 0.25);
}
:host-context(body.theme-dark) .filter-price-field:focus-within {
  border-color: var(--fc-brand, #5ea1d8);
}
:host-context(body.theme-dark) .filter-price-field .price-currency {
  color: #64748b;
}
:host-context(body.theme-dark) .filter-input {
  color: #f1f5f9;
}
:host-context(body.theme-dark) .filter-input::placeholder {
  color: #475569;
}
:host-context(body.theme-dark) .price-range-sep {
  color: #475569;
}
:host-context(body.theme-dark) .filter-modal-footer {
  border-top-color: rgba(148, 163, 184, 0.15);
}
:host-context(body.theme-dark) .filter-reset-btn {
  background: #111827;
  color: #94a3b8;
}
:host-context(body.theme-dark) .filter-reset-btn:hover {
  background: #374151;
  color: #e2e8f0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/search/search.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAEF;AAAE;EACE,eAAA;EACA,kBAAA;EACA,+BAAA;AAEJ;;AAEA,oEAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,8BAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,qDAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;EACA,oBAAA;AACF;;AAEA;;EAEE,kBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;AACF;;AAEA;EACE,QAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA,yCAAA;AACA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,6BAAA;AACF;AACE;EACE,YAAA;EACA,uBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AACJ;AAEE;EACE,OAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AAAJ;;AAIA,uEAAA;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;wBAAA;AA2IA;EACE,eAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,0BAAA;EACA,yBAAA;EACA,+BAAA;EACA,gBAAA;EACA,+BAAA;EACA,YAAA;AAFF;;AAKA;EACE,4BAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAFF;;AAKA,8DAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;AAFF;;AAKA,6BAAA;AACA;EACE;IACE,aAAA;IACA,uBAAA;IAEA,oBAAA,EAAA,+CAAA;EAHF;EAMA;IACE,mBAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,YAAA;IACA,yBAAA;IACA,mBAAA;EAJF;EAcA;IACE,QAAA;EAZF;AACF;AAeA,wBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;AAbF;;AAgBA;EACE,aAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,OAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;AAbF;AAeE;EACE,aAAA;AAbJ;;AAiBA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;EACA,aAAA;AAdF;AAgBE;EAGE,aAAA;EACA,YAAA;EACA,gBAAA;AAhBJ;;AAoBA;EACE,yBAAA;AAjBF;;AAoBA;EACE,0CAAA;EACA,cAAA;AAjBF;;AAoBA,+BAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;AAjBF;AAmBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAjBJ;AAoBE;EAAU,yBAAA;AAjBZ;AAmBE;EACE,0CAAA;EACA,WAAA;AAjBJ;;AAqBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAlBF;;AAqBA,uBAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,4BAAA;AAlBF;;AAqBA;EACE;IAAO,UAAA;EAjBP;EAkBA;IAAO,UAAA;EAfP;AACF;AAiBA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;EACA,2CAAA;EACA,qDAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAfF;AAiBE;EAdF;IAeI,SAAA;IACA,WAAA;IACA,YAAA;IACA,QAAA;IACA,gCAAA;IACA,YAAA;IACA,mBAAA;IACA,qDAAA;IACA,gBAAA;EAdF;AACF;;AAiBA;EACE;IAAO,2BAAA;EAbP;EAcA;IAAO,wBAAA;EAXP;AACF;AAaA;EACE;IAAO,UAAA;IAAY,4CAAA;EATnB;EAUA;IAAO,UAAA;IAAY,yCAAA;EANnB;AACF;AAQA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gCAAA;EACA,cAAA;AANF;;AASA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AANF;;AASA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;AANF;AAQE;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,iBAAA;AAFzD;AAIE;EAAU,mBAAA;AADZ;;AAIA;EACE,OAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,SAAA;AADF;;AAIA,sBAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AADF;;AAIA;EACE,mBAAA;EACA,WAAA;EACA,6BAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;AADF;AAGE;EAAU,mBAAA;AAAZ;AAEE;EACE,mBAAA;EACA,sCAAA;EACA,cAAA;EACA,gBAAA;AAAJ;;AAIA,uBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,OAAA;EACA,8BAAA;AADF;AAGE;EAAiB,sCAAA;AAAnB;AAEE;EACE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;UAAA,iBAAA;AAAJ;;AAIA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;AADF;AAGE;EAAiB,WAAA;AAAnB;AAEE;EAEE,wBAAA;EACA,SAAA;AADJ;;AAKA;EACE,WAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAKA,sDAAA;AACA;EACE,sBAAA;EACA,6BAAA;EACA,cAAA;AAFF;;AAKA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;AAFF;AAIE;EAAU,mBAAA;AADZ;AAGE;EACE,WAAA;AADJ;;AAKA,2EAAA;AACA;EACE,gBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;EACA,yBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAKA;;EAEE,oCAAA;EACA,aAAA;AAFF;;AAKA,eAAA;AACA;EACE,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AAFF;;AAKA;EACE,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,wBAAA;EACA,kCAAA;AAFF;;AAKA;EACE;IACE,2BAAA;EAFF;AACF;AAKA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAHF;;AAMA;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,oCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAHF;AAKE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;AAJF;AAME;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAJJ;;AAQA,oFAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AALF;AAOE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AALJ;;AASA,wEAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,wCAAA,EAAA,0BAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,uCAAA;UAAA,+BAAA;AANF;;AASA;EACE,aAAA;EACA,MAAA,EAAA,oDAAA;AANF;;AASA,6DAAA;AACA;EACE;IACE,gBAAA;EANF;AACF;AASA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AAPF;;AAUA;EACE,OAAA;EACA,YAAA;EACA,aAAA,EAAA,mBAAA;EACA,sBAAA;EACA,MAAA,EAAA,4BAAA;EACA,SAAA;EACA,UAAA;AAPF;;AAUA;EACE,aAAA;EACA,uBAAA;EACA,QAAA,EAAA,0CAAA;EACA,SAAA,EAAA,+BAAA;EACA,2BAAA;EACA,UAAA;EACA,8BAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,6BAAA;EACA,gBAAA,EAAA,uCAAA;EACA,oBAAA;EACA,qBAAA,EAAA,qCAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA,EAAA,0BAAA;EACA,qBAAA;EACA,sBAAA;AAPF;;AAUA;EACE,cAAA;AAPF;;AAUA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,wBAAA;EACA,cAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAPF;AASE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;AAPJ;AAUE;EACE,cAAA;EACA,yBAAA;AARJ;;AAYA;EACE,UAAA;AATF;;AAYA,+DAAA;AACA;EACE;IACE,UAAA,EAAA,6BAAA;EATF;AACF;AAYA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA,EAAA,qCAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA,EAAA,wBAAA;EACA,8BAAA;EACA,kBAAA;AAVF;;AAaA;EACE,cAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA,EAAA,8BAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAVF;;AAaA;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAVF;;AAaA;EACE,cAAA;AAVF;;AAaA,qEAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAVF;AAYE;EACE,kBAAA;EACA,UAAA;AAVJ;AAaE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AAXJ;AAcE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AAZJ;AAcI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AAZN;AAeI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAbN;;AAkBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAfF;AAiBE;EAAU,0BAAA;AAdZ;;AAiBA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,eAAA;AAdF;AAeE;EAAU,0BAAA;AAZZ;;AAeA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAZF;;AAeA;EACE,eAAA;AAZF;;AAeA;EACE,eAAA;EACA,QAAA;EACA,YAAA;EACA,+BAAA;AAZF;;AAeA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,yEAAA;EACA,uBAAA;EACA,YAAA;AAZF;AAcE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;AAZJ;AAeE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;AAbJ;AAeI;EACE,mBAAA;AAbN;AAiBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAfJ;AAkBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAhBJ;AAmBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAjBJ;AAoBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAlBJ;;AAsBA;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA,EAAA,gCAAA;EACA,gBAAA;AAnBF;;AAsBA;;EAEE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;AAnBF;;AAsBA,2DAAA;AACA;EACE,kBAAA;AAnBF;;AAsBA;EACE,iBAAA;EACA,aAAA;EACA,gBAAA;AAnBF;;AAsBA,8DAAA;AAEA;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AApBF;;AAuBA,cAAA;AACA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,UAAA;AApBF;;AAuBA;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iCAAA;AApBF;;AAuBA;EACE,yBAAA;AApBF;;AAuBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApBF;;AAuBA;EACE,OAAA;EACA,YAAA;AApBF;;AAuBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AApBF;;AAuBA;EACE,cAAA;AApBF;;AAuBA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AApBF;;AAuBA;EACE,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AApBF;;AAuBA;EACE,mBAAA;EACA,cAAA;AApBF;;AAuBA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AApBF;;AAuBA;EACE,YAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,2CAAA;EACA,sBAAA;AApBF;;AAuBA;EACE;IACE,yBAAA;EApBF;AACF;AAuBA;EACE,yBAAA;AArBF;;AAwBA;EACE,yBAAA;EACA,cAAA;AArBF;;AAwBA,qBAAA;AACA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,WAAA;EACA,kBAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,mBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;AArBF;;AAwBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,cAAA;AArBF;;AAwBA;EACE,OAAA;EACA,YAAA;AArBF;;AAwBA;EACE,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AArBF;;AAwBA;EACE,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AArBF;;AAwBA;EACE,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,UAAA;AArBF;;AAwBA;EACE,OAAA;EACA,YAAA;AArBF;;AAwBA;EACE,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AArBF;;AAwBA;EACE,UAAA;EACA,YAAA;AArBF;;AAwBA;EACE,oBAAA;AArBF;AAuBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AArBJ;;AAyBA;EACE,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,mBAAA;EACA,WAAA;AAtBF;;AAyBA;EACE;IACE,4BAAA;EAtBF;EAwBA;IACE,2BAAA;EAtBF;AACF;AAyBA,oBAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAvBF;;AA0BA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;AAvBF;;AA0BA;EACE;IACE,uBAAA;EAvBF;EAyBA;IACE,yBAAA;EAvBF;AACF;AA0BA,gBAAA;AACA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;AAxBF;;AA2BA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAxBF;;AA2BA,sBAAA;AACA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;AAxBF;;AA2BA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAxBF;;AA2BA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AAxBF;;AA2BA;EACE,OAAA;EACA,YAAA;AAxBF;;AA2BA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AAxBF;;AA2BA;EACE,eAAA;EACA,cAAA;AAxBF;;AA2BA,iBAAA;AACA;EACE,gBAAA;AAxBF;;AA2BA,sBAAA;AACA;EACE;IACE,4BAAA;EAxBF;EA2BA;IACE,cAAA;EAzBF;EA4BA;IACE,wBAAA;EA1BF;EA6BA;IACE,kBAAA;EA3BF;AACF;AA8BA;EACE;IACE,qCAAA;EA5BF;AACF;AA+BA;EACE;IACE,cAAA;EA7BF;EAgCA;IACE,cAAA;EA9BF;EAiCA;IACE,aAAA;EA/BF;EAkCA;IACE,qCAAA;IACA,SAAA;EAhCF;EAmCA;IACE,0BAAA;EAjCF;AACF;AAoCA;EACE;IACE,aAAA;EAlCF;EAqCA;IACE,YAAA;EAnCF;EAsCA;IACE,eAAA;IACA,eAAA;EApCF;EAuCA;IACE,iBAAA;EArCF;EAwCA;IACE,0BAAA;IACA,SAAA;EAtCF;EAyCA;IACE,YAAA;EAvCF;AACF;AA0CA,uCAAA;AACA;EACE,kCAAA;EACA;IACE,2BAAA;EAxCF;EA0CA;IACE,2BAAA;EAxCF;EA0CA;;IAEE,2BAAA;EAxCF;AACF;AA2CA;EACE,yCAAA;EACA;;IAEE,2BAAA;EAzCF;AACF;AA4CA,6CAAA;AACA;EACE,YAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AA1CF;;AA6CA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AA1CF;;AA6CA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AA1CF;;AA6CA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,QAAA;AA1CF;;AA6CA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AA1CF;;AA6CA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iCAAA;AA1CF;;AA6CA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA1CF;;AA6CA;EACE;IACE,aAAA;IACA,eAAA;IACA,cAAA;IACA,kBAAA;IACA,iCAAA;EA1CF;AACF;AA6CA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA3CF;;AA8CA;EACE;IACE,aAAA;EA3CF;AACF;AA8CA,2BAAA;AACA;EAoDE,qFAAA;EAuMA,oCAAA;EA4BA,+BAAA;EAkBA,gCAAA;EAKA,uBAAA;EAoBA,0BAAA;EAKA,eAAA;EAeA,uBAAA;EAkBA,WAAA;AA3YF;AAoCE;EACE,yBAAA;AAlCJ;AAqCE;EACE,mBAAA;EACA,iDAAA;AAnCJ;AAqCI;EACE,cAAA;AAnCN;AAsCI;EACE,mBAAA;EACA,uCAAA;EACA,cAAA;AApCN;AAsCM;EACE,cAAA;AApCR;AAyCE;EACE,oCAAA;EACA,iDAAA;EACA,oFAAA;EACA,mBAAA;EACA,gBAAA;AAvCJ;AA0CE;EACE,uBAAA;EACA,iBAAA;AAxCJ;AA2CE;EACE,yBAAA;EACA,cAAA;AAzCJ;AA4CE;;EAEE,yBAAA;AA1CJ;AA6CE;EACE,0CAAA;EACA,cAAA;AA3CJ;AA+CE;;;EAGE,oCAAA;EACA,yBAAA;EACA,gCAAA;AA7CJ;AAgDE;EACE,yBAAA;AA9CJ;AAiDE;EACE,+CAAA;EACA,yBAAA;AA/CJ;AAkDE;;EAEE,+CAAA;AAhDJ;AAmDE;EACE;IACE,oCAAA;IACA,uBAAA;IACA,2BAAA;IACA,wBAAA;IACA,mBAAA;IACA,gBAAA;EAjDJ;EAoDE;IACE,iBAAA;EAlDJ;EAqDE;IACE,oCAAA;IACA,yBAAA;EAnDJ;EAsDE;;;IAGE,oCAAA;IACA,yBAAA;EApDJ;EAuDE;IACE,qDAAA;IACA,yBAAA;EArDJ;EAwDE;;;IAGE,oCAAA;IACA,yBAAA;IACA,gCAAA;EAtDJ;EAyDE;IACE,yBAAA;EAvDJ;AACF;AA0DE;EACE,yBAAA;AAxDJ;AA2DE;EACE,cAAA;AAzDJ;AA4DE;EACE,cAAA;AA1DJ;AA6DE;EACE,cAAA;AA3DJ;AA8DE;EACE,cAAA;AA5DJ;AAgEI;EACE,qBAAA;AA9DN;AAgEI;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AA9DN;AAkEE;EAAc,cAAA;AA/DhB;AAgEE;EAAiB,cAAA;AA7DnB;AA+DE;EACE,cAAA;AA7DJ;AAgEE;EACE,cAAA;EACA,2CAAA;AA9DJ;AAiEE;;EAEE,yCAAA;EACA,cAAA;AA/DJ;AAkEE;EACE,yBAAA;EACA,0CAAA;AAhEJ;AAmEE;EACE,yBAAA;AAjEJ;AAoEE;EACE,cAAA;AAlEJ;AAqEE;EACE,cAAA;AAnEJ;AAsEE;EACE,oCAAA;EACA,cAAA;AApEJ;AAuEE;EACE,mCAAA;EACA,cAAA;AArEJ;AAwEE;EACE,yBAAA;EACA,cAAA;AAtEJ;AAyEE;EACE,yBAAA;AAvEJ;AA0EE;EACE,0CAAA;EACA,cAAA;AAxEJ;AA2EE;EACE,yBAAA;AAzEJ;AA4EE;;;;;;;EAOE,yEAAA;EACA,0BAAA;AA1EJ;AA6EE;;EAEE,cAAA;AA3EJ;AA8EE;EACE,yBAAA;EACA,8CAAA;AA5EJ;AA+EE;;EAEE,cAAA;AA7EJ;AAgFE;EACE,yBAAA;AA9EJ;AAiFE;EACE,yBAAA;AA/EJ;AAkFE;EACE,kCAAA;AAhFJ;AAoFE;EACE,mBAAA;EACA,wEAAA;AAlFJ;AAoFI;EACE,cAAA;EACA,8CAAA;AAlFN;AAqFI;EACE,mBAAA;AAnFN;AAsFI;EACE,qBAAA;EACA,mBAAA;AApFN;AAuFI;EACE,cAAA;AArFN;AAwFI;EACE,cAAA;AAtFN;AA2FE;EACE,mBAAA;EACA,cAAA;AAzFJ;AA2FI;EAAU,mBAAA;AAxFd;AA0FI;EACE,oCAAA;EACA,WAAA;AAxFN;AA4FE;EACE,mBAAA;EACA,cAAA;AA1FJ;AA8FE;EACE,8BAAA;AA5FJ;AAgGE;EACE,mBAAA;EACA,0CAAA;AA9FJ;AAiGE;EACE,8CAAA;AA/FJ;AAkGE;EACE,cAAA;AAhGJ;AAmGE;EACE,cAAA;AAjGJ;AAmGI;EAAU,qCAAA;AAhGd;AAoGE;EACE,cAAA;AAlGJ;AAsGE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AApGJ;AAsGI;EAAU,mBAAA;EAAqB,cAAA;AAlGnC;AAoGI;EACE,oCAAA;EACA,sCAAA;EACA,cAAA;AAlGN;AAuGE;EACE,mBAAA;EACA,uCAAA;AArGJ;AAuGI;EAAiB,sCAAA;AApGrB;AAsGI;EAAkB,cAAA;AAnGtB;AAsGE;EACE,cAAA;AApGJ;AAsGI;EAAiB,cAAA;AAnGrB;AAsGE;EAAmB,cAAA;AAnGrB;AAsGE;EACE,2CAAA;AApGJ;AAuGE;EACE,mBAAA;EACA,cAAA;AArGJ;AAuGI;EAAU,mBAAA;EAAqB,cAAA;AAnGnC","sourcesContent":[".no-results-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 16px;\n  text-align: center;\n  color: #8c8c8c;\n\n  mat-icon {\n    font-size: 48px;\n    margin-bottom: 8px;\n    color: var(--fc-brand, #5ea1d8);\n  }\n}\n\n/* Search Content - No margin needed, app.component handles layout */\n.search-content {\n  padding: 24px;\n  background-color: #ffffff;\n  min-height: calc(100vh - 56px);\n  width: 100%;\n}\n\n.org-library-home {\n  margin-bottom: 24px;\n}\n\n.org-library-home__header h2 {\n  margin: 0 0 12px;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.org-library-empty {\n  color: #777;\n  margin: 0 0 16px;\n  font-size: 0.9rem;\n}\n\n.org-library-thumb {\n  background: linear-gradient(135deg, #eef5fb, #f7faf8);\n  position: relative;\n}\n\n.org-library-thumb .thumbnail-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.org-library-thumb__placeholder {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--fc-brand, #5ea1d8);\n}\n\n.org-library-thumb__placeholder mat-icon {\n  font-size: 48px;\n  width: 48px;\n  height: 48px;\n}\n\n.org-library-home .video-card {\n  cursor: pointer;\n}\n\n.org-library-home .video-card.skeleton-card {\n  cursor: default;\n  pointer-events: none;\n}\n\n.org-library-type-label,\n.org-library-status {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.org-library-status {\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: rgba(94, 161, 216, 0.12);\n  color: #0b3d5c;\n}\n\n.org-library-home .channel-meta-row {\n  gap: 6px;\n  min-width: 0;\n}\n\n.org-library-home .channel-info {\n  min-width: 0;\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n\n.org-library-home .channel-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.org-library-home .org-library-unique-id,\n.org-library-home .video-views {\n  flex: 0 0 auto;\n  max-width: 45%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-left: 4px;\n}\n\n/* Mobile search header for search page */\n.mobile-search-header {\n  position: sticky;\n  top: 0;\n  z-index: 8;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-bottom: 1px solid #eee;\n\n  .icon-btn {\n    border: none;\n    background: transparent;\n    padding: 6px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: #212427;\n  }\n\n  .mobile-search-input {\n    flex: 1;\n    height: 36px;\n    padding: 0 12px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    font-size: 14px;\n    outline: none;\n  }\n}\n\n/* All header, sidebar, and layout styles moved to app.component.scss */\n\n/* COMMENTED OUT - These styles are now in app.component.scss\n.flow-header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.menu-button {\n  background: none;\n  border: none;\n  color: #000000;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n}\n\n.menu-button:hover {\n  background-color: #f0f0f0;\n}\n\n.flow-logo {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.flow-logo img {\n  height: 20px;\n  width: auto;\n}\n\n.flow-search-container {\n  flex: 1;\n  max-width: 640px;\n  margin: 0 40px;\n}\n\n.search-box {\n  display: flex;\n  align-items: center;\n  background-color: #ffffff;\n  border: 1px solid #d0d0d0;\n  border-radius: 40px;\n  overflow: hidden;\n  height: 40px;\n}\n\n.flow-search-input {\n  flex: 1;\n  background: none;\n  border: none;\n  color: #000000;\n  padding: 0 16px;\n  font-size: 16px;\n  outline: none;\n}\n\n.flow-search-input::placeholder {\n  color: #666666;\n}\n\n.search-button {\n  background: #f5f5f5;\n  border: none;\n  color: #000000;\n  padding: 8px 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n}\n\n.search-button:hover {\n  background-color: #e0e0e0;\n}\n\n.flow-header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.header-icon {\n  background: none;\n  border: none;\n  color: #000000;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  transition: background-color 0.2s;\n}\n\n.header-icon:hover {\n  background-color: #f0f0f0;\n}\n\n.notification-badge {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  background-color: #ff0000;\n  color: white;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.profile-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.profile-image {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n/* Flow layout sidebar */\n.flow-sidebar {\n  position: fixed;\n  left: 0;\n  top: 56px;\n  width: 240px;\n  height: calc(100vh - 56px);\n  background-color: #ffffff;\n  border-right: 1px solid #e0e0e0;\n  overflow-y: auto;\n  transition: transform 0.3s ease;\n  z-index: 999;\n}\n\n.flow-sidebar.sidebar-collapsed {\n  transform: translateX(-100%);\n}\n\n.sidebar-content {\n  padding: 12px 0;\n}\n\n.sidebar-section {\n  margin-bottom: 8px;\n}\n\n.sidebar-section h3 {\n  color: #666666;\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: uppercase;\n  padding: 8px 24px;\n  margin: 0;\n}\n\n.sidebar-item {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  width: 100%;\n  padding: 10px 24px;\n  background: none;\n  border: none;\n  color: #000000;\n  cursor: pointer;\n  font-size: 14px;\n  text-align: left;\n  transition: background-color 0.2s;\n}\n\n.sidebar-item:hover {\n  background-color: #f0f0f0;\n}\n\n.sidebar-item.active {\n  background-color: #f0f0f0;\n  font-weight: 500;\n}\n\n.sidebar-item mat-icon {\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n}\n\n/* Search Content - Full width, app.component handles layout */\n.search-content {\n  padding: 24px;\n  background-color: #ffffff;\n  min-height: 100vh;\n  width: 100%;\n}\n\n/* Mobile Responsive Styles */\n@media (max-width: 768px) {\n  .search-content {\n    padding: 12px;\n    padding: 0px !important;\n    // padding-top: calc(56px + 12px);\n    padding-bottom: 60px; /* prevent content underlap with fixed footer */\n  }\n\n  .category-filter-bar {\n    margin-bottom: 16px;\n    margin-top: 6px;\n    padding: 8px 16px;\n    position: sticky;\n    z-index: 999;\n    background-color: #ffffff;\n    align-items: center;\n  }\n\n  // When translate banner is visible, add extra margin\n  // body:has(.goog-te-banner-frame) {\n  //   .category-filter-bar {\n  //     margin-top: 120px; // Header (56px) + Translate banner (~64px)\n  //   }\n  // }\n\n  .video-grid {\n    gap: 8px;\n  }\n}\n\n/* Category Filter Bar */\n.category-filter-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n  overflow-x: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.category-filter-bar::-webkit-scrollbar {\n  display: none;\n}\n\n.category-scroll-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-bottom: 0;\n  flex: 1;\n  overflow-x: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.category-chip {\n  background-color: #f0f0f0;\n  color: #000000;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 16px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background-color 0.2s;\n  outline: none;\n  \n  &:focus,\n  &:active,\n  &:focus-visible {\n    outline: none;\n    border: none;\n    box-shadow: none;\n  }\n}\n\n.category-chip:hover {\n  background-color: #e0e0e0;\n}\n\n.category-chip.active {\n  background-color: var(--fc-brand, #5ea1d8);\n  color: #ffffff;\n}\n\n/* ── Filter toggle button ── */\n.filter-toggle-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  margin-left: auto;\n  background: #f0f0f0;\n  color: #000;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 16px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background-color 0.2s;\n  position: relative;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    line-height: 18px;\n  }\n\n  &:hover { background-color: #e0e0e0; }\n\n  &.filter-active {\n    background-color: var(--fc-brand, #5ea1d8);\n    color: #fff;\n  }\n}\n\n.filter-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  border-radius: 9px;\n  background: #fff;\n  color: var(--fc-brand, #5ea1d8);\n  font-size: 11px;\n  font-weight: 700;\n  margin-left: 2px;\n  padding: 0 4px;\n}\n\n/* ── Filter modal ── */\n.filter-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  z-index: 1000;\n  animation: fadeIn 0.15s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n.filter-modal {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #fff;\n  border-radius: 20px 20px 0 0;\n  z-index: 1001;\n  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.12);\n  animation: slideUp 0.22s cubic-bezier(0.4, 0, 0.2, 1);\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n\n  @media (min-width: 600px) {\n    left: 50%;\n    right: auto;\n    bottom: auto;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: 420px;\n    border-radius: 16px;\n    animation: scaleIn 0.18s cubic-bezier(0.4, 0, 0.2, 1);\n    max-height: 90vh;\n  }\n}\n\n@keyframes slideUp {\n  from { transform: translateY(100%); }\n  to   { transform: translateY(0); }\n}\n\n@keyframes scaleIn {\n  from { opacity: 0; transform: translate(-50%, -48%) scale(0.96); }\n  to   { opacity: 1; transform: translate(-50%, -50%) scale(1); }\n}\n\n.filter-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px 12px;\n  border-bottom: 1px solid #f0f0f0;\n  flex-shrink: 0;\n}\n\n.filter-modal-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #111;\n}\n\n.filter-modal-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #555;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  transition: background 0.15s;\n\n  mat-icon { font-size: 20px; width: 20px; height: 20px; line-height: 20px; }\n\n  &:hover { background: #f0f0f0; }\n}\n\n.filter-modal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.filter-section {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.filter-section-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #555;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0;\n}\n\n/* Sort option pills */\n.filter-sort-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.filter-sort-btn {\n  background: #f0f0f0;\n  color: #333;\n  border: 2px solid transparent;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n  white-space: nowrap;\n\n  &:hover { background: #e4e4e4; }\n\n  &.selected {\n    background: #e8f2fb;\n    border-color: var(--fc-brand, #5ea1d8);\n    color: #1d67a3;\n    font-weight: 600;\n  }\n}\n\n/* Price range inputs */\n.filter-price-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.filter-price-field {\n  display: flex;\n  align-items: center;\n  background: #f8f9fa;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  padding: 0 10px;\n  flex: 1;\n  transition: border-color 0.15s;\n\n  &:focus-within { border-color: var(--fc-brand, #5ea1d8); }\n\n  .price-currency {\n    color: #777;\n    font-size: 13px;\n    margin-right: 4px;\n    user-select: none;\n  }\n}\n\n.filter-input {\n  border: none;\n  outline: none;\n  width: 100%;\n  padding: 9px 0;\n  font-size: 15px;\n  background: transparent;\n  color: #111;\n\n  &::placeholder { color: #aaa; }\n\n  &::-webkit-inner-spin-button,\n  &::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n}\n\n.price-range-sep {\n  color: #bbb;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n/* Modal footer — only shown when filters are active */\n.filter-modal-footer {\n  padding: 8px 20px 20px;\n  border-top: 1px solid #f0f0f0;\n  flex-shrink: 0;\n}\n\n.filter-reset-btn {\n  background: #f5f5f5;\n  color: #444;\n  border: none;\n  padding: 11px 20px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n\n  &:hover { background: #eaeaea; }\n\n  &--full {\n    width: 100%;\n  }\n}\n\n/* Multi-item Items query terms (same chip look; row above category tabs) */\n.item-query-terms-bar {\n  margin-bottom: 0;\n}\n\n.item-query-term-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: default;\n  padding-right: 6px;\n  background-color: #e3f2fd !important;\n  color: #1d67a3 !important;\n  border: 1px solid #bfdbfe;\n}\n\n.item-query-term-text {\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #1d67a3 !important;\n}\n\n.item-query-term-remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 24px;\n  min-height: 24px;\n  margin: 0;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  background: rgba(29, 103, 163, 0.14);\n  color: #1d67a3;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.item-query-term-remove:hover,\n.item-query-term-remove:focus-visible {\n  background: rgba(29, 103, 163, 0.24);\n  outline: none;\n}\n\n/* Video Grid */\n.video-grid-container {\n  width: 100%;\n}\n\n.video-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  padding: 0;\n  width: 100%;\n}\n\n.video-card {\n  background-color: transparent;\n  border-radius: 12px;\n  overflow: hidden;\n  transition: transform 0.2s;\n  cursor: pointer;\n  content-visibility: auto;\n  contain-intrinsic-size: auto 280px;\n}\n\n@media (hover: hover) and (pointer: fine) {\n  .video-card:hover {\n    transform: translateY(-2px);\n  }\n}\n\n.video-thumbnail {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16/9;\n  background-color: #f5f5f5;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 12px;\n}\n\n.thumbnail-image,\n.thumbnail-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.video-duration {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n\n  .duration-icon {\n    font-size: 13px;\n    width: 13px;\n    height: 13px;\n    line-height: 13px;\n  }\n}\n\n.bundle-badge {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  z-index: 10;\n  width: 25px !important;\n  height: 25px !important;\n  max-width: 25px !important;\n\n  img {\n    width: 100% !important;\n    height: auto !important;\n    object-fit: contain;\n    border: none;\n  }\n}\n\n/* Sponsored badge — bottom-left corner of thumbnail, same style as duration badge */\n.sponsored-card-badge {\n  position: absolute;\n  bottom: 8px;\n  left: 8px;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  pointer-events: none;\n\n  mat-icon {\n    font-size: 13px;\n    width: 13px;\n    height: 13px;\n    line-height: 13px;\n  }\n}\n\n/* Price badge in the top-right corner with 50% transparent background */\n.price-badge {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 10;\n  background-color: rgb(33 36 39 / 77%); /* Flowchest black @ 50% */\n  color: var(--fc-brand, #5ea1d8);\n  font-weight: 600;\n  font-size: 20px;\n  margin: -7px;\n  line-height: 1;\n  padding: 6px 10px;\n  border-radius: 6px;\n  backdrop-filter: saturate(120%);\n}\n\n.video-info {\n  display: flex;\n  gap: 0; /* no gap since avatar is now inside video-details */\n}\n\n/* Mobile-only tweak: slight left margin for video info row */\n@media (max-width: 768px) {\n  .video-info {\n    margin-left: 5px;\n  }\n}\n\n.video-avatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.avatar-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.avatar-icon {\n  width: 100%;\n  height: 100%;\n  font-size: 70px;\n  color: #666666 !important;\n}\n\n.video-details {\n  flex: 1;\n  min-width: 0;\n  display: flex; /* stacked layout */\n  flex-direction: column;\n  gap: 0; /* no spacing between rows */\n  margin: 0;\n  padding: 0;\n}\n\n.video-title-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px; /* proper spacing between title and menu */\n  margin: 0; /* no extra space below title */\n  margin-bottom: 0 !important;\n  padding: 0;\n  justify-content: space-between;\n}\n\n.video-title {\n  font-size: 16px;\n  font-weight: 500;\n  color: #000000;\n  margin: 0;\n  margin-bottom: 0px !important;\n  line-height: 1.3; /* proper line height for readability */\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* allow 2 lines to show full title */\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  flex: 1;\n  min-width: 0;\n  padding: 0;\n  padding-right: 4px; /* space for menu button */\n  word-wrap: break-word;\n  word-break: break-word;\n}\n\n.video-title:hover {\n  color: #666666;\n}\n\n.video-menu-button {\n  background: none;\n  border: none;\n  color: #212427;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.2s;\n  flex-shrink: 0;\n  margin: 0;\n  margin-top: 0 !important;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  min-height: 28px;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    margin: 0;\n    padding: 0;\n    line-height: 1;\n  }\n\n  &:hover {\n    color: #212427;\n    background-color: #f5f5f5;\n  }\n}\n\n.video-card:hover .video-menu-button {\n  opacity: 1;\n}\n\n/* Mobile: Show unique code and more_vert icon always visible */\n@media (max-width: 768px) {\n  .video-menu-button {\n    opacity: 1; /* Always visible on mobile */\n  }\n}\n\n.channel-meta-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  margin: 0;\n  margin-top: -2px !important; /* negative margin to eliminate gap */\n  padding: 0;\n  flex-wrap: nowrap;\n  line-height: 1; /* minimal line height */\n  justify-content: space-between;\n  position: relative;\n}\n\n.channel-meta-row > *:not(.video-views) {\n  flex-shrink: 0;\n}\n\n.channel-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  margin: 0;\n  margin-top: 2px; /* slight spacing from title */\n}\n\n.channel-avatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.avatar-image-small {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.avatar-icon-small {\n  width: 100%;\n  height: 100%;\n  font-size: 24px;\n  color: #212427;\n}\n\n.channel-name {\n  font-size: 13px;\n  color: #606060;\n  margin: 0px !important;\n  margin-top: 0px !important;\n  margin-bottom: 0px !important;\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  line-height: 1.3;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.channel-name:hover {\n  color: #000000;\n}\n\n/* YouTube-style collab: overlapping avatars + \"name and @coauthor\" */\n.avatar-stack {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n\n  .video-avatar {\n    position: relative;\n    z-index: 1;\n  }\n\n  .collab-avatar-overlap {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    object-fit: cover;\n    margin-left: -7px;\n    border: 2px solid #fff;\n    z-index: 2;\n    position: relative;\n    flex-shrink: 0;\n  }\n\n  .collab-avatar-extra {\n    position: relative;\n    width: 20px;\n    height: 20px;\n    margin-left: -7px;\n    z-index: 3;\n    flex-shrink: 0;\n    cursor: pointer;\n\n    .collab-extra-img {\n      width: 20px;\n      height: 20px;\n      border-radius: 50%;\n      object-fit: cover;\n      border: 2px solid #fff;\n      display: block;\n    }\n\n    .collab-extra-badge {\n      position: absolute;\n      bottom: -3px;\n      right: -4px;\n      background: #3b82f6;\n      color: #fff;\n      font-size: 7px;\n      font-weight: 700;\n      border-radius: 8px;\n      padding: 1px 3px;\n      line-height: 1.2;\n      white-space: nowrap;\n    }\n  }\n}\n\n.collab-extra-count-text {\n  font-size: 11px;\n  font-weight: 600;\n  color: #6b7280;\n  cursor: pointer;\n\n  &:hover { text-decoration: underline; }\n}\n\n.collab-sep {\n  color: #888;\n  font-weight: 400;\n  font-size: 11px;\n}\n\n.collab-coname {\n  font-weight: 500;\n  cursor: pointer;\n  &:hover { text-decoration: underline; }\n}\n\n.avatar-stack-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.collab-stack-clickable {\n  cursor: pointer;\n}\n\n.collab-popup-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 499;\n  background: rgba(0, 0, 0, 0.45);\n}\n\n.collab-popup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 500;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.22), 0 2px 10px rgba(0, 0, 0, 0.1);\n  padding: 20px 16px 14px;\n  width: 300px;\n\n  .collab-popup-title {\n    font-size: 11px;\n    font-weight: 700;\n    color: #6b7280;\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #f3f4f6;\n    margin-bottom: 10px;\n    text-align: center;\n  }\n\n  .collab-popup-card {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 10px 10px;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background 0.15s;\n\n    &:hover {\n      background: #f5f7fa;\n    }\n  }\n\n  .collab-popup-avatar-wrap {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    overflow: hidden;\n    flex-shrink: 0;\n    border: 2px solid #e5e7eb;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f3f4f6;\n  }\n\n  .collab-popup-pic {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n  }\n\n  .collab-popup-icon {\n    font-size: 34px;\n    width: 34px;\n    height: 34px;\n    color: #9ca3af;\n    line-height: 1;\n  }\n\n  .collab-popup-uname {\n    font-size: 13px;\n    font-weight: 600;\n    color: #1a1a2e;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 200px;\n  }\n}\n\n.video-meta {\n  display: flex;\n  gap: 4px;\n  font-size: 12px;\n  color: #606060;\n  margin: 0;\n  margin-top: 2px; /* slight spacing from channel */\n  line-height: 1.3;\n}\n\n.video-views,\n.video-time {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 600;\n  color: #1d67a3;\n  background-color: #e3f2fd;\n  padding: 3px 8px;\n  border-radius: 4px;\n  white-space: nowrap;\n  display: inline-block;\n  line-height: 1.2;\n  letter-spacing: 0.3px;\n  align-self: center;\n  margin-left: auto;\n}\n\n/* Align unique code with more_vert icon on the same line */\n.video-details {\n  position: relative;\n}\n\n.channel-meta-row .video-views {\n  margin-left: auto;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n/* .video-price replaced by overlay price-badge on thumbnail */\n\n.price-tag {\n  background-color: #ff0000;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n/* User Grid */\n.user-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 16px;\n  padding: 0;\n}\n\n.user-card {\n  background-color: #f9f9f9;\n  border-radius: 12px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  transition: background-color 0.2s;\n}\n\n.user-card:hover {\n  background-color: #f0f0f0;\n}\n\n.user-avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n  cursor: pointer;\n  background: linear-gradient(135deg, #f5f5f5 0%, #f5f5f5 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.user-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.user-name {\n  font-size: 16px;\n  font-weight: 500;\n  color: #000000;\n  margin: 0 0 4px 0;\n  cursor: pointer;\n}\n\n.user-name:hover {\n  color: #666666;\n}\n\n.user-fullname {\n  font-size: 14px;\n  color: #666666;\n  margin: 0 0 12px 0;\n}\n\n.user-role-chip {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  background: #eef5fb;\n  color: var(--fc-brand, #5ea1d8);\n}\n\n.user-role-chip--none {\n  background: #fff1e0;\n  color: #b45309;\n}\n\n.follow-button {\n  background-color: #f0f0f0;\n  color: #000000;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 18px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.follow-button:disabled {\n  opacity: 0.8;\n  cursor: not-allowed;\n}\n\n.btn-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 6px;\n  animation: follow-spin 0.7s linear infinite;\n  vertical-align: middle;\n}\n\n@keyframes follow-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.follow-button:hover {\n  background-color: #e0e0e0;\n}\n\n.follow-button.following {\n  background-color: #000000;\n  color: #ffffff;\n}\n\n/* Skeleton Loading */\n.skeleton-card {\n  background-color: #f9f9f9;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.skeleton-thumbnail {\n  width: 100%;\n  aspect-ratio: 16/9;\n  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  margin-bottom: 12px;\n}\n\n.skeleton-info {\n  display: flex;\n  gap: 12px;\n  padding: 0 12px 12px 12px;\n}\n\n.skeleton-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  flex-shrink: 0;\n}\n\n.skeleton-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.skeleton-title {\n  height: 16px;\n  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  margin-bottom: 8px;\n  width: 80%;\n}\n\n.skeleton-channel {\n  height: 14px;\n  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  margin-bottom: 4px;\n  width: 60%;\n}\n\n.skeleton-meta {\n  height: 14px;\n  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  width: 40%;\n}\n\n.skeleton-user-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.skeleton-name {\n  height: 16px;\n  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  margin-bottom: 8px;\n  width: 70%;\n}\n\n.skeleton-name--short {\n  width: 45%;\n  height: 12px;\n}\n\n.user-card.skeleton-card {\n  pointer-events: none;\n\n  .skeleton-user-avatar {\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    flex-shrink: 0;\n  }\n}\n\n.skeleton-button {\n  height: 32px;\n  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 16px;\n  width: 80px;\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n/* Loading Spinner */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f0f0f0;\n  border-top: 4px solid #000000;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* End Message */\n.end-message {\n  text-align: center;\n  padding: 40px 20px;\n  color: #666666;\n}\n\n.end-message h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 400;\n}\n\n/* Notification Menu */\n.notification-menu {\n  max-width: 400px;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.notification-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.notification-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.notification-avatar-icon {\n  width: 40px;\n  height: 40px;\n  font-size: 40px;\n  color: #666666;\n  flex-shrink: 0;\n}\n\n.notification-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.notification-message {\n  display: block;\n  font-size: 14px;\n  color: #000000;\n  margin: 0 0 4px 0;\n  line-height: 1.5;\n  white-space: pre-line;\n}\n\n.notification-time {\n  font-size: 12px;\n  color: #666666;\n}\n\n/* Profile Menu */\n.profile-menu {\n  min-width: 200px;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .flow-sidebar {\n    transform: translateX(-100%);\n  }\n\n  .flow-main-content {\n    margin-left: 0;\n  }\n\n  .flow-sidebar.sidebar-collapsed {\n    transform: translateX(0);\n  }\n\n  .flow-main-content.sidebar-collapsed {\n    margin-left: 240px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .video-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .flow-header {\n    padding: 0 8px;\n  }\n\n  .flow-search-container {\n    margin: 0 16px;\n  }\n\n  .flow-main-content {\n    padding: 16px;\n  }\n\n  .video-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n\n  .user-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .flow-search-container {\n    margin: 0 8px;\n  }\n\n  .search-box {\n    height: 36px;\n  }\n\n  .flow-search-input {\n    font-size: 14px;\n    padding: 0 12px;\n  }\n\n  .search-button {\n    padding: 6px 12px;\n  }\n\n  .video-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .flow-main-content {\n    padding: 8px;\n  }\n}\n\n/* Card edge behaviors on search page */\n@media (min-width: 993px) {\n  /* Desktop: square edge on hover */\n  .video-card:hover {\n    border-radius: 0 !important;\n  }\n  .video-card:hover .video-thumbnail {\n    border-radius: 0 !important;\n  }\n  .video-card:hover .thumbnail-image,\n  .video-card:hover .thumbnail-video {\n    border-radius: 0 !important;\n  }\n}\n\n@media (max-width: 767px) {\n  /* Mobile: full-width with square edges */\n  .video-card,\n  .video-thumbnail {\n    border-radius: 0 !important;\n  }\n}\n\n/* Mobile Bottom Navigation (keep existing) */\n.div1 {\n  height: 50px;\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: #ffffff;\n  overflow: hidden;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-top: 1px solid #e0e0e0;\n}\n\n.foot-ico {\n  width: 100%;\n  margin: 0px auto;\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n.foot-ico ul {\n  display: flex;\n  list-style: none;\n  align-items: center;\n  justify-content: center;\n  margin: 0px;\n  width: 100%;\n  padding: 0px;\n}\n\n.foot-ico ul li {\n  margin: 0px;\n  width: 25px;\n  height: 25px;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.foot-ico ul li span {\n  color: #666666;\n  font-size: 20px;\n  text-align: center;\n  display: block;\n}\n\n.foot-ico ul li .icon-text {\n  font-size: 10px;\n  color: #666666;\n  text-align: center;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.foot-ico ul li img {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n}\n\n@media (min-width: 992px) {\n  .div1 {\n    display: none;\n    font-size: 10px;\n    color: #666666;\n    text-align: center;\n    font-family: \"Roboto\", sans-serif;\n  }\n}\n\n.foot-ico ul li img {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n}\n\n@media (min-width: 992px) {\n  .div1 {\n    display: none;\n  }\n}\n\n/* Search page dark theme */\n:host-context(body.theme-dark) {\n  .search-content {\n    background-color: #0a0c10;\n  }\n\n  .mobile-search-header {\n    background: #0f172a;\n    border-bottom: 1px solid rgba(148, 163, 184, 0.2);\n\n    .icon-btn {\n      color: #e2e8f0;\n    }\n\n    .mobile-search-input {\n      background: #111827;\n      border-color: rgba(148, 163, 184, 0.35);\n      color: #e2e8f0;\n\n      &::placeholder {\n        color: #94a3b8;\n      }\n    }\n  }\n\n  .category-filter-bar {\n    background-color: #0a0c10 !important;\n    border-bottom: 1px solid rgba(148, 163, 184, 0.2);\n    /* More air so the rule is not tight against the chips (above) or the grid (below) */\n    margin-bottom: 20px;\n    padding-top: 4px;\n  }\n\n  .category-scroll-container {\n    background: transparent;\n    padding-bottom: 0;\n  }\n\n  .category-chip {\n    background-color: #1f2937;\n    color: #e5e7eb;\n  }\n\n  .category-chip:hover,\n  .category-chip:active {\n    background-color: #374151;\n  }\n\n  .category-chip.active {\n    background-color: var(--fc-brand, #5ea1d8);\n    color: #ffffff;\n  }\n\n  /* Keep Items multi-term chips identical to search/header badge colors in dark mode */\n  .item-query-term-chip,\n  .item-query-term-chip.category-chip,\n  .item-query-term-chip.category-chip.active {\n    background-color: #e3f2fd !important;\n    color: #1d67a3 !important;\n    border-color: #bfdbfe !important;\n  }\n\n  .item-query-term-chip .item-query-term-text {\n    color: #1d67a3 !important;\n  }\n\n  .item-query-term-chip .item-query-term-remove {\n    background: rgba(29, 103, 163, 0.14) !important;\n    color: #1d67a3 !important;\n  }\n\n  .item-query-term-chip .item-query-term-remove:hover,\n  .item-query-term-chip .item-query-term-remove:focus-visible {\n    background: rgba(29, 103, 163, 0.24) !important;\n  }\n\n  @media (max-width: 768px) {\n    .category-filter-bar {\n      background-color: #0a0c10 !important;\n      border: none !important;\n      box-shadow: none !important;\n      outline: none !important;\n      margin-bottom: 18px;\n      padding-top: 2px;\n    }\n\n    .category-scroll-container {\n      padding-bottom: 0;\n    }\n\n    .category-chip {\n      background-color: #1f2937 !important;\n      color: #e5e7eb !important;\n    }\n\n    .category-chip:hover,\n    .category-chip:active,\n    .category-chip:focus-visible {\n      background-color: #374151 !important;\n      color: #f8fafc !important;\n    }\n\n    .category-chip.active {\n      background-color: var(--fc-brand, #5ea1d8) !important;\n      color: #ffffff !important;\n    }\n\n    .item-query-term-chip,\n    .item-query-term-chip.category-chip,\n    .item-query-term-chip.category-chip.active {\n      background-color: #e3f2fd !important;\n      color: #1d67a3 !important;\n      border-color: #bfdbfe !important;\n    }\n\n    .item-query-term-chip .item-query-term-text {\n      color: #1d67a3 !important;\n    }\n  }\n\n  .video-thumbnail {\n    background-color: #111827;\n  }\n\n  .video-title {\n    color: #f3f4f6;\n  }\n\n  .video-title:hover {\n    color: #d1d5db;\n  }\n\n  .channel-name {\n    color: #9ca3af;\n  }\n\n  .channel-name:hover {\n    color: #e5e7eb;\n  }\n\n  .avatar-stack {\n    .collab-avatar-overlap {\n      border-color: #1f2937;\n    }\n    .collab-avatar-extra {\n      border-color: #1f2937;\n      background: #374151;\n      color: #d1d5db;\n    }\n  }\n\n  .collab-sep { color: #6b7280; }\n  .collab-coname { color: #9ca3af; }\n\n  .video-menu-button {\n    color: #cbd5e1;\n  }\n\n  .video-menu-button:hover {\n    color: #f8fafc;\n    background-color: rgba(255, 255, 255, 0.08);\n  }\n\n  .video-views,\n  .video-time {\n    background-color: rgba(94, 161, 216, 0.2);\n    color: #93c5fd;\n  }\n\n  .user-card {\n    background-color: #111827;\n    border: 1px solid rgba(148, 163, 184, 0.2);\n  }\n\n  .user-card:hover {\n    background-color: #1f2937;\n  }\n\n  .user-name {\n    color: #f3f4f6;\n  }\n\n  .user-fullname {\n    color: #9ca3af;\n  }\n\n  .user-role-chip {\n    background: rgba(94, 161, 216, 0.25);\n    color: #bae6fd;\n  }\n\n  .user-role-chip--none {\n    background: rgba(245, 158, 11, 0.2);\n    color: #fcd34d;\n  }\n\n  .follow-button {\n    background-color: #1f2937;\n    color: #e5e7eb;\n  }\n\n  .follow-button:hover {\n    background-color: #374151;\n  }\n\n  .follow-button.following {\n    background-color: var(--fc-brand, #5ea1d8);\n    color: #ffffff;\n  }\n\n  .skeleton-card {\n    background-color: #111827;\n  }\n\n  .skeleton-thumbnail,\n  .skeleton-avatar,\n  .skeleton-title,\n  .skeleton-channel,\n  .skeleton-meta,\n  .skeleton-name,\n  .skeleton-button {\n    background: linear-gradient(90deg, #1f2937 25%, #374151 50%, #1f2937 75%);\n    background-size: 200% 100%;\n  }\n\n  .end-message,\n  .no-results-message {\n    color: #9ca3af;\n  }\n\n  .div1 {\n    background-color: #0f172a;\n    border-top: 1px solid rgba(148, 163, 184, 0.2);\n  }\n\n  .foot-ico ul li .icon-text,\n  .foot-ico ul li span {\n    color: #cbd5e1;\n  }\n\n  .avatar-icon {\n    color: #94a3b8 !important;\n  }\n\n  .avatar-icon-small {\n    color: #94a3b8 !important;\n  }\n\n  .user-avatar {\n    background: transparent !important;\n  }\n\n  /* Collaborators popup — dark mode */\n  .collab-popup {\n    background: #1f2937;\n    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.6), 0 2px 10px rgba(0, 0, 0, 0.4);\n\n    .collab-popup-title {\n      color: #64748b;\n      border-bottom-color: rgba(148, 163, 184, 0.15);\n    }\n\n    .collab-popup-card:hover {\n      background: #374151;\n    }\n\n    .collab-popup-avatar-wrap {\n      border-color: #374151;\n      background: #111827;\n    }\n\n    .collab-popup-icon {\n      color: #6b7280;\n    }\n\n    .collab-popup-uname {\n      color: #e2e8f0;\n    }\n  }\n\n  /* ── Filter toggle button ── */\n  .filter-toggle-btn {\n    background: #1f2937;\n    color: #e5e7eb;\n\n    &:hover { background: #374151; }\n\n    &.filter-active {\n      background: var(--fc-brand, #5ea1d8);\n      color: #fff;\n    }\n  }\n\n  .filter-badge {\n    background: #0f172a;\n    color: #93c5fd;\n  }\n\n  /* ── Filter modal backdrop ── */\n  .filter-modal-backdrop {\n    background: rgba(0, 0, 0, 0.6);\n  }\n\n  /* ── Filter modal ── */\n  .filter-modal {\n    background: #1e293b;\n    box-shadow: 0 -4px 32px rgba(0, 0, 0, 0.5);\n  }\n\n  .filter-modal-header {\n    border-bottom-color: rgba(148, 163, 184, 0.15);\n  }\n\n  .filter-modal-title {\n    color: #f1f5f9;\n  }\n\n  .filter-modal-close {\n    color: #94a3b8;\n\n    &:hover { background: rgba(148, 163, 184, 0.12); }\n  }\n\n  /* ── Filter sections ── */\n  .filter-section-label {\n    color: #64748b;\n  }\n\n  /* Sort pills */\n  .filter-sort-btn {\n    background: #111827;\n    color: #cbd5e1;\n    border-color: transparent;\n\n    &:hover { background: #374151; color: #f1f5f9; }\n\n    &.selected {\n      background: rgba(94, 161, 216, 0.15);\n      border-color: var(--fc-brand, #5ea1d8);\n      color: #93c5fd;\n    }\n  }\n\n  /* Price range inputs */\n  .filter-price-field {\n    background: #111827;\n    border-color: rgba(148, 163, 184, 0.25);\n\n    &:focus-within { border-color: var(--fc-brand, #5ea1d8); }\n\n    .price-currency { color: #64748b; }\n  }\n\n  .filter-input {\n    color: #f1f5f9;\n\n    &::placeholder { color: #475569; }\n  }\n\n  .price-range-sep { color: #475569; }\n\n  /* Footer */\n  .filter-modal-footer {\n    border-top-color: rgba(148, 163, 184, 0.15);\n  }\n\n  .filter-reset-btn {\n    background: #111827;\n    color: #94a3b8;\n\n    &:hover { background: #374151; color: #e2e8f0; }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
